import { render, staticRenderFns } from "./centerTutorial.vue?vue&type=template&id=e5cfb4da&scoped=true&"
import script from "./centerTutorial.vue?vue&type=script&lang=js&"
export * from "./centerTutorial.vue?vue&type=script&lang=js&"
import style0 from "./centerTutorial.vue?vue&type=style&index=0&id=e5cfb4da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cfb4da",
  null
  
)

export default component.exports